export default __webpack_public_path__ + "static/media/Handle Request.e5ccb2bf.png";